import { render, staticRenderFns } from "./logo-btn.vue?vue&type=template&id=c8a4d550&scoped=true&lang=pug"
import script from "./logo-btn.vue?vue&type=script&lang=coffee"
export * from "./logo-btn.vue?vue&type=script&lang=coffee"
import style0 from "./logo-btn.vue?vue&type=style&index=0&id=c8a4d550&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a4d550",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CraftVisual: require('/opt/build/repo/site/components/globals/craft-visual.coffee').default})
